<div>
  <div class="theme-main-menu sticky-menu theme-menu-five" [ngClass]="headerSticky ? 'fixed' : ''">
    <div class="d-flex align-items-center justify-content-center">
      <div class="logo"><a [routerLink]="['/']"><img src="assets/images/logo/deski_06.svg" alt=""></a></div>

      <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
        <div class="nav-container">
          <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
            [ngClass]="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" (click)="handleNavToggle()">
            <span></span>
          </button>
          <div class="navbar-collapse collapse" id="collapsibleNavbar">
            <div class="d-lg-flex justify-content-between align-items-center">
              <ul class="navbar-nav main-side-nav font-gordita" data-bs-toggle="collapse"
                data-bs-target="#collapsibleNavbar" id="one-page-nav">
                <li class="nav-item dropdown position-static">
                  <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Home</a>
                  <div class="dropdown-menu">
                    <!-- nav menu start -->
                    <app-mega-menu></app-mega-menu>
                  </div> <!-- /.dropdown-menu -->
                </li>
                <li class="nav-item">
                  <a [routerLink]="['./']" fragment="feature" class="nav-link" (click)="handleNavToggle()">Features</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['./']" fragment="product" class="nav-link" (click)="handleNavToggle()">Product
                    Details</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['./']" fragment="testimonials" class="nav-link"
                    (click)="handleNavToggle()">Testimonials</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <div class="right-widget">
        <a [routerLink]="['./']" data-bs-toggle="modal" data-bs-target="#contactModal" class="demo-button"><span>Contact
            us</span> <img src="assets/images/icon/user.svg" alt=""></a>
      </div>
    </div>
  </div>
  <!-- contact modal -->
  <app-contact-modal></app-contact-modal>
</div>